import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ItineraryRoutingModule } from './itinerary-routing.module';
import { ItineraryComponent } from './itinerary.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FullCalendarModule } from '@fullcalendar/angular';
import { NgImageSliderModule } from 'ng-image-slider';


@NgModule({
  declarations: [
    ItineraryComponent
  ],
  imports: [
    CommonModule,
    ItineraryRoutingModule,
    SharedModule,
    FullCalendarModule,
    NgImageSliderModule
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ItineraryModule { }
